import React from 'react';
import CarouselComponent from '../components/CarouselComponent';
import ContactComponent from '../components/ContactComponent';
import ServiceComponent from '../components/ServiceComponent';
import AdvantageComponent from '../components/AdvantageComponent';
import CaseComponent from '../components/CaseComponent';
import TeamComponent from '../components/TeamComponent';
import { MENU } from '../constants/index'

const Home: React.FC<{ setMenu: React.Dispatch<React.SetStateAction<string>> }> = ({ setMenu }) => {
  return (
    <div>
      <CarouselComponent setMenu={setMenu} />
      <ContactComponent />
      <ServiceComponent menuKey={MENU.home} setMenu={setMenu} />
      <AdvantageComponent />
      <CaseComponent menuKey={MENU.home} setMenu={setMenu} />
      <TeamComponent setMenu={setMenu} />
     </div>
  );
};

export default Home;